import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
      <div className="flex min-h-screen items-center justify-center p-4">
        <Card className="w-full max-w-md text-center">
          <CardContent className="pt-6 pb-6">
            <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900">
              <Search className="h-12 w-12 text-blue-600 dark:text-blue-400" />
            </div>
            
            <h1 className="text-6xl font-bold text-gray-900 dark:text-gray-100 mb-4">404</h1>
            
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
              Page Not Found
            </h2>
            
            <p className="text-gray-600 dark:text-gray-400 mb-8">
              Sorry, we couldn't find the page you're looking for. The page might have been moved, deleted, or you entered the wrong URL.
            </p>
            
            <div className="space-y-3">
              <Button 
                onClick={() => navigate('/')} 
                className="w-full"
                size="lg"
              >
                <Home className="mr-2 h-4 w-4" />
                Go to Dashboard
              </Button>
              
              <Button 
                variant="outline" 
                onClick={() => navigate(-1)}
                className="w-full"
                size="lg"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go Back
              </Button>
            </div>
            
            <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Need help? Contact our{' '}
                <a 
                  href="mailto:support@leadgpt.com" 
                  className="text-blue-600 hover:underline dark:text-blue-400"
                >
                  support team
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}